import React from "react";
import BetSelections from "@tvg/design-system/src/components/betSelections";
import formatCurrency from "@tvg/formatter/currency";
import { Paragraph, useColorTokens, useTheme } from "@tvg/design-system";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import {
  Container,
  ContentContainer,
  Grid,
  Header,
  Item,
  TitleContainer
} from "./styled-components";
import { getPayoffSelectionLabel } from "../utils";
import { Selections } from "../../../types";

export interface WagerResultProps {
  amount: number;
  payout: number;
  betName: string;
  selections: Selections[];
  selectionsDirection?: "row" | "col";
  isRefund: boolean;
  isPick: boolean;
  raceNumber: number;
  pickStr?: string;
}

const WagerResult = ({
  amount = 0,
  betName = "",
  payout = 0,
  selections,
  selectionsDirection = "row",
  isRefund = false,
  isPick = false,
  raceNumber = 0,
  pickStr = ""
}: WagerResultProps) => {
  const colorTokens = useColorTokens();
  const { space } = useTheme();

  return (
    <Container>
      <Header>
        <TitleContainer>
          <Paragraph qaLabel="wager-title" color={colorTokens.content.default}>
            {`${formatCurrency(amount)} ${betName}`}
          </Paragraph>
          {pickStr && (
            <Paragraph
              ml="space-1"
              qaLabel="wager-title"
              color={colorTokens.content.subtle}
            >
              {`(${pickStr})`}
            </Paragraph>
          )}
        </TitleContainer>
        <Paragraph
          ml="auto"
          fontFamily="medium"
          qaLabel="payout-title"
          color={colorTokens.content.default}
        >
          {isRefund ? "Refund" : formatCurrency(payout)}
        </Paragraph>
      </Header>
      {!isRefund && (
        <ContentContainer>
          <Grid
            gap={
              selectionsDirection === "row"
                ? space["space-5"]
                : space["space-3"]
            }
            numberOfCols={selectionsDirection === "col" ? 1 : selections.length}
          >
            {selections.length > 0 ? (
              selections.map((item, index) => (
                <Item
                  isCol={selectionsDirection === "row"}
                  key={index.toString()}
                >
                  <Paragraph
                    mb={selectionsDirection === "row" ? "space-1" : 0}
                    mr={selectionsDirection === "col" ? "space-3" : 0}
                    qaLabel="selection-title"
                    color={colorTokens.content.subtle}
                  >
                    <>
                      {getPayoffSelectionLabel(
                        index,
                        isPick,
                        raceNumber,
                        selections.length
                      )}
                    </>
                  </Paragraph>
                  <BetSelections
                    qaLabel="wager-selections"
                    type={WagerTypeCodesEnum.WIN}
                    selections={item}
                    showBetType={false}
                  />
                </Item>
              ))
            ) : (
              <Paragraph
                qaLabel="selection-title"
                color={colorTokens.content.subtle}
              >
                CarryOver
              </Paragraph>
            )}
          </Grid>
        </ContentContainer>
      )}
    </Container>
  );
};

export default WagerResult;
